<template>
  <div class="my_title_index" v-if="!title.text.isHidden">
    <div class="module_banner" :style="{
      textAlign:title.font[title.font.radio_val].textAlign,
      height:title.height[title.height.radio_val].height + 'px',
      backgroundColor: title.background.radio_val !== 'hidden' ? title.background[title.background.radio_val].color : '',
      backgroundImage:title.background.radio_val !== 'hidden' && title.background[title.background.radio_val].img !== '' ? 'url('+title.background[title.background.radio_val].img+')' : 'none',
      backgroundSize: title.background.radio_val !== 'hidden' ? title.background[title.background.radio_val].background_size : 'auto',
      backgroundRepeat: title.background.radio_val !== 'hidden' ? title.background[title.background.radio_val].background_repeat : 'repeat',
      backgroundPosition: title.background.radio_val !== 'hidden' ? title.background[title.background.radio_val].background_position : '0% 0%',
    }">
      <span class="module_banner_text jz_theme_font_color" :style="{
      fontSize:title.font[title.font.radio_val].fontSize + 'px',
      fontFamily: title.font[title.font.radio_val].fontFamily,
      fontStyle: title.font[title.font.radio_val].fsItalics,
      textDecoration:title.font[title.font.radio_val].fontUnderline,
      fontWeight:title.font[title.font.radio_val].fsWeight,
      lineHeight:title.height[title.height.radio_val].height + 'px',
      ...linear_gradient
      }">{{title.text.value}}</span>
    </div>
  </div>

</template>

<script>
    export default {
      name: "my_title_index",
      props: {
        title: {
          type: Object,
          default:{}
        },
      },
      created(){
        if(!this.title.text.isHidden){
          this.title.font.default.fontColor_globalColor = this.$store.state.myRender.common.theme_color;
        }
      },
      computed:{
        linear_gradient(){
          const pattern = this.title.font[this.title.font.radio_val].pattern;
          const linear_gradient = this.title.font[this.title.font.radio_val].linear_gradient;
          if(pattern === 'linear_gradient'){
            const obj = {};
            obj.backgroundImage = 'linear-gradient(' + linear_gradient.deg +
              'deg,' + linear_gradient.start_color + linear_gradient.start_pointer +
              '%,' + linear_gradient.end_color + linear_gradient.end_pointer + '%)';
            obj.color = 'rgba(0, 0, 0,0)';
            return obj;
          }
          else{
            return {
              color:this.title.font[this.title.font.radio_val].fontColor_globalColor,
            };
          }
        }
      }
    }
</script>

<style scoped lang="scss">
  .my_title_index{
    width: 100%;
    border-bottom: 1px solid #e5e5e5;
    .module_banner{
      overflow: hidden;
    }
    .module_banner_text{
      display: inline-block;
      margin-left: 6px;
      margin-right: 6px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-background-clip: text;
      padding-right: 10px;
      width: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/my_title_index/index.vue